import { render } from "./ItemInfo.vue?vue&type=template&id=377d7c2a&scoped=true&ts=true"
import script from "./ItemInfo.vue?vue&type=script&lang=ts"
export * from "./ItemInfo.vue?vue&type=script&lang=ts"

import "./ItemInfo.vue?vue&type=style&index=0&id=377d7c2a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377d7c2a"]])

export default __exports__